import React, { Component } from 'react'
import { UserIcon, UserGroupIcon, PencilAltIcon, TrashIcon, ChartPieIcon, PlusIcon, SearchIcon, ArrowRightIcon, ArrowLeftIcon } from '@heroicons/react/outline';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getTournamentList, deleteTournament } from '../../../modules/tournament';
import { tournamentDialogDisplay } from "./tournament-field-mapper";
import TournamentDialog from "../tournaments/tournament-dialog";
import moment from 'moment';
import Moment from 'react-moment';
import { toast } from 'react-toastify';

class TournamentCreator extends Component {
    constructor(props) {
        super(props)
        this.state = {
            navigate: '',
            searchString: '',
            renderPreviewDialog: false,
            previewTournamentData: ""
        }
    }

    componentDidMount() {
        const { searchString } = this.props;
        this.setState({ ...this.state, searchString });
        this.getTournamentsList();
    }

    getTournamentsList() {
        const { searchString } = this.state;
        const { dispatch, token, offset, limit } = this.props;
        dispatch(getTournamentList(token, offset, limit, searchString));
    }

    formatDates(tournaments) {
        let _tournaments = []
        for (let tournament of tournaments) {
            const t = { ...tournament, startDate: new Date(tournament.startDate), endDate: new Date(tournament.endDate) }
            _tournaments.push(t)
        }
        return _tournaments;
    }

    submitSearch(event) {
        event.preventDefault();
        const { searchString } = this.state;
        const { dispatch, token, limit } = this.props;
        dispatch(getTournamentList(token, 0, limit, searchString));
    }

    async handleDelete(tournamentId) {
        const { token, tournaments } = this.props;

        const tournament = tournaments.filter(t => t.tournamentId === tournamentId)[0]
        if (window.confirm(`You are deleting ${tournament.businessGroupName}:${tournament.gameName} tournament starting on ${moment(tournament.startDate).format("LLL")}. Proceed?`)) {
            try {
                await deleteTournament(token, tournamentId)
                toast.success(
                    `DELETED: ${tournament.gameName} tournament on ${moment(tournament.startDate).format("LLL")} at ${tournament.businessGroupName}.`,
                    { position: toast.POSITION.TOP_CENTER }
                )
                this.getTournamentsList();
            } catch (e) {
                console.error(e)
            }
        }
    }

    handlePreview(tournamentId) {
        const { tournaments } = this.props;
        const tournament = tournaments.filter(t => t.tournamentId === tournamentId)[0]
        this.setState({ ...this.state, renderPreviewDialog: true, previewTournamentData: tournamentDialogDisplay(tournament) });
    }

    changePage(pageNum) {
        const { searchString } = this.state;
        const { dispatch, token, limit } = this.props;
        dispatch(getTournamentList(token, pageNum, limit, searchString));
    }

    render() {
        const { navigate, searchString, renderPreviewDialog, previewTournamentData } = this.state;
        const { token, tournaments, totalNumOfTournaments, offset, limit } = this.props;
        if (navigate !== '') {
            return (<Redirect to={navigate} />)
        }
        const _tournaments = this.formatDates(tournaments);

        console.log(offset, limit);
        var numOfPages = Math.ceil(totalNumOfTournaments / limit);
        console.log(numOfPages);

        return (
            <div className="tw-mx-10 tw-my-5">
                <div className="tw-container tw-h-16 tw-text-left"><h1 className="tw-font-extrabold tw-text-2xl">I'm a Tournament creator watch me roar.</h1></div>
                <div className="tw-container tw-h-10 tw-flex tw-items-left">
                    <button className="tw-btn tw-btn-primary" onClick={() => this.setState({ navigate: '/tournament/new' })}>
                        <span>Create</span>
                        <PlusIcon className="tw-h-6 tw-w-6" />
                    </button>
                    <form className="tw-w-full tw-max-w-sm tw-mx-5" onSubmit={e => this.submitSearch(e, searchString)}>
                        <div className="tw-relative tw-flex tw-w-full tw-flex-wrap tw-items-stretch tw-mb-3">
                            <input type="text" placeholder="Search by business group, game, title, etc..." className="tw-search-input" value={searchString} onChange={(e) => this.setState({ ...this.state, searchString: e.target.value })} />
                            <span className="tw-z-10 tw-h-full tw-leading-snug tw-font-normal tw-absolute tw-text-center tw-text-blueGray-300 tw-absolute tw-bg-transparent tw-rounded tw-text-base tw-items-center tw-justify-center tw-w-8 tw-right-0 tw-pr-3 tw-py-2">
                                <SearchIcon className="tw-h-6 tw-w-6 tw-cursor-pointer" onClick={e => this.submitSearch(e, searchString)} />
                            </span>
                        </div>
                    </form>
                </div>

                <div className="tw--mx-4 sm:tw--mx-8 tw-px-4 sm:tw-px-8 tw-py-4 tw-overflow-x-auto">
                    <div className="tw-inline-block tw-min-w-full tw-shadow tw-rounded-lg tw-overflow-hidden">
                        <table className="tw-min-w-full tw-leading-normal">
                            <thead>
                                <tr>
                                    <th className="tw-th">
                                        Business Group
                                    </th>
                                    <th className="tw-th">
                                        Game
                                    </th>
                                    <th className="tw-th">
                                        Title
                                    </th>
                                    <th className="tw-th">
                                        Date Start
                                    </th>
                                    <th className="tw-th">
                                        Date End
                                    </th>
                                    <th className="tw-th">
                                        Status
                                    </th>
                                    <th className="tw-th">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    _tournaments.map((tournament, i) =>
                                        <tr key={tournament.tournamentId}>
                                            <td className="tw-td">
                                                <p className="tw-text-gray-900 tw-whitespace-no-wrap">{tournament.businessGroupName}</p>
                                            </td>
                                            <td className="tw-td">
                                                <div className="tw-inline-flex">
                                                    {
                                                        tournament.gameType === "SinglePlayer" &&
                                                        <UserIcon className="tw-h-6 tw-w-6" />
                                                    }
                                                    {
                                                        tournament.gameType === "MultiPlayer" &&
                                                        <UserGroupIcon className="tw-h-6 tw-w-6" />
                                                    }
                                                    &nbsp;&nbsp;<p className="tw-text-gray-900 tw-whitespace-no-wrap">{tournament.gameName}</p>
                                                </div>
                                            </td>
                                            <td className="tw-td">
                                                <p className="tw-text-gray-900 tw-whitespace-no-wrap">{tournament.tournamentName}</p>
                                            </td>
                                            <td className="tw-td">
                                                <p className="tw-text-gray-900 tw-whitespace-no-wrap"><Moment format="LLL">{tournament.startDate}</Moment></p>
                                            </td>
                                            <td className="tw-td">
                                                <p className="tw-text-gray-900 tw-whitespace-no-wrap"><Moment format="LLL">{tournament.endDate}</Moment></p>
                                            </td>
                                            <td className="tw-td">
                                                <p className="tw-text-gray-900 tw-whitespace-no-wrap">{tournament.tournamentStatus}</p>
                                            </td>
                                            <td className="tw-td">
                                                <div className="tw-inline-flex">
                                                    <PencilAltIcon className="tw-h-6 tw-w-6 tw-cursor-pointer" onClick={() => this.setState({ navigate: `/tournament/${tournament.tournamentId}` })} />&nbsp;&nbsp;
                                                    {tournament.canDelete && <TrashIcon className="tw-h-6 tw-w-6 tw-cursor-pointer" onClick={() => this.handleDelete(tournament.tournamentId)} />}
                                                    {tournament.hasStats && <ChartPieIcon className="tw-h-6 tw-w-6 tw-cursor-pointer" onClick={() => this.handlePreview(tournament.tournamentId)} />}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <button className="tw-btn tw-btn-secondary" disabled={offset <= 0}
                            onClick={e => {
                                this.changePage((offset - 1));
                            }}>
                            <ArrowLeftIcon className="tw-h-6 tw-w-6 tw-cursor-pointer" />
                        </button>
                        &nbsp;&nbsp;&nbsp;
                        <label htmlFor=""> {(offset + 1)}&nbsp;/&nbsp;{numOfPages}</label>
                        &nbsp;&nbsp;&nbsp;
                        <button className="tw-btn tw-btn-secondary" disabled={offset >= (numOfPages - 1)}
                            onClick={e => {
                                this.changePage((offset + 1));
                            }
                            }>
                            <ArrowRightIcon className="tw-h-6 tw-w-6 tw-cursor-pointer" />
                        </button>
                    </div>
                    {renderPreviewDialog ? (
                        <TournamentDialog
                            hide_func={() =>
                                this.setState({ ...this.state, renderPreviewDialog: false })
                            }
                            tournament_data={previewTournamentData}
                            show={true}
                            token={token}
                        />
                    ) : null}
                </div>
            </div >
        )
    }
}

const withState = connect(state => {
    const { tournament, user } = state;
    return { ...tournament, token: user.token, searchString: "" };
})

export default withState(TournamentCreator);


// WEBPACK FOOTER //
// ./src/components/containers/tournament-creator/tournament-creator.js